'use strict';

import $ from 'jquery';
import cssVars from 'css-vars-ponyfill';

import Provider 			from '../common/model/Provider';
import Config 				from '../common/model/Config';
import ModuleParam 			from '../common/model/ModuleParam';
import GlobalVar 			from '../common/model/GlobalVar';
import UmdOption 			from '../common/model/UmdOption';
import { fileGet } 			from "../common/utils/ajax";
import { mTransKey } 		from '../common/utils/mTransKeyEvt';
import {device, deviceWBKHeight, deviceWBKWitdh, isDevice_TB_WBK_Portrait, isPC_TB_MO} from '../common/utils/deviceCheck';
import { ajax } 			from '../common/controller/ajaxCtrl';

import {rendering}			from './controller/renderingViewCtrl';
import {viewEvent}			from './controller/viewEventCtrl';
import {viewAsyn} 			from './controller/viewAsynProcessing';
import { vaild }			from './controller/validationCtrl';
import { mobile } from './controller/mobileCtrl';

cssVars({ 
	// Treat all browsers as legacy
	onlyLegacy: false, 
});

if(Config.system.alert_debug){
	alert("load app.js");
}
if(Config.system.alert_debug){
	alert(isPC_TB_MO());
}

/* Css Load  */
require('../common/resource/css/demo_mobile.css');
require('../common/resource/css/demo_common.css');
require('../common/resource/css/main.css');
require('../common/resource/css/common.css');

require('./resource/css/style_common.css');
require('./resource/css/style_mobile.css');


//외부에서 접근가능한 MODULE OPTIONS
// export const options = umdOptions; 
export const options = UmdOption; 

export function LOAD_MODULE(configPath, json, callback, closeEvt, loadedModule){
	// umdOptions.init();
	Provider.clear();

	ModuleParam.setModuleParam(configPath, json, callback);
	Provider.setProvider(json);
	GlobalVar.setUserInfo(json);
	GlobalVar.closeEvt = closeEvt;
	GlobalVar.loadedModule = loadedModule;

	var path = configPath;
	fileGet(path).then(function(res){
		Config.setConfig(res);
		
		if(Config.system.alert_debug){
			alert("Setting Config: ",JSON.stringify(Config));
		}
		if(Config.system.console_debug){
			console.log("Setting Config: ",Config);
		}
		initModule(callback);
	},function(res){
		
	});
}

// 인증요청 
export function MODULE_REQUEST(configPath, json){
	Provider.setProvider(json);

	const errMsg = Provider.getUserInfoValidMesseg(json)
	if(!!errMsg){
		OACX.options.callback.valid.error(errMsg)
		return false; 
	}

	// DeviceInfo 설정
	device.init();
	// Config File Load
	fileGet(configPath).then(async function(res){
		Config.setConfig(res);
		if(Config.system.alert_debug){alert("Setting Config: ",JSON.stringify(Config))}
		if(Config.system.console_debug){console.log("Setting Config: ",Config)}
		try {
			await ajax.getToken()
			//인증요청
			await ajax.requestAuth()
		} catch(e) { }
	});

}
// 인증완료 
export async function MODULE_RESULT(){
	//DeviceInfo 값 갱신
	device.init();
	try {
		//인증완료
		await ajax.finishAuth()
	} catch(e) { }
}

function initModule(callback){

	//세로보드 카카오 웹브라우저 비율 체크 isDevice_TB_WBK_Portrait = true 
	device.portraitTBWidthSizeCheck();

	//DeviceInfo 값 갱신
	device.init();

	//html template rendering
	rendering.createTemplateView();
	viewEvent.init();
	if(Config.mTranskey.use){
		mTransKey.init();
	}
	vaild.init();

	if(Provider.deviceInfo.code == "MO"){
		mobile.init();
	}else{
		//카카오톡 브라우저
		if(Provider.deviceInfo.browser == "WBK"){
			if(isDevice_TB_WBK_Portrait){
				//세로보드 카카오 웹브라우저 비율 체크 및 모바일 실행
				mobile.init();
			}
			//가로 세로 변환에 따른 모듈 재로드
			device.orientChangeTBProccesing();
			device.resizeTBProccesing(function(){
				viewEvent.view_msg("안내","","화면 전환을 감지했습니다. 정상적인 간편인증을 위하여 화면 종료 후 다시 실행해 주시기 바랍니다.",viewEvent.closePopup);
			});
		}
	}

	//Token, Provider 정보 추출
	viewAsyn.getTokenProviderListPopup();
	
	//Step2 인증완료 Handler
	viewEvent.successEventHandler(callback);
}